export default {
  global: {
    html: { 
      fontSize: "15px"
    },
    h2: {
      fontSize: "3xl",
      fontWeight: "semibold"
    },
    h3: {
      fontSize: "2xl",
      fontWeight: "medium"
    }
  }
};
